import './team-radio.style.sass';
import template from './team-radio.tpl.pug';

export default {
    selector: 'dbATeamRadio',
    template: template(),
    bindings: {
        name: '<',
        selected: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/team-radio/team-radio.cmpt.js